
















































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import VarietyHeader from '@/app/components/Variety/VarietyHeader.vue'
/* api */
import VarietyEditApi from '@/app/model/api/varietyEditApi'
import VarietyDetailApi from '@/app/model/api/varietyDetailApi'
import Toast from '@/app/components/Common/Toast.vue'
/* module */
import CommonClass from '@/app/module/common'
import { routerPath } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    VarietyHeader,
    Toast
  }
})

export default class VarietyEdit extends Vue {
  private errorMessages: any = {}
  private toastMessage: string = ''
  private stageArrow: any = ['1', '2', '3', '4']
  private testStageArrow: any = ['1', '2', '3', '4']
  /* 表示非表示 */
  private showErrorAlert: boolean = false
  private showLoading: boolean = true
  private testValueSelected: any = [
    { text: '無効', value: 0 },
    { text: '有効', value: 1 }
  ]
  /* data */
  private varietyId: string = ''
  private varietyData: {[key: string]: any} = {
    variety_name: '',
    grade_name: '',
    season: '',
    area_name: '',
    stage_goals: [
      {
        growth_step: 1,
        integrated_temperature: 0,
        stem_number: 0,
        growth_height: 0,
        stage_name: ''
      },
      {
        growth_step: 2,
        integrated_temperature: 0,
        stem_number: 0,
        growth_height: 0,
        stage_name: ''
      },
      {
        growth_step: 3,
        integrated_temperature: 0,
        stem_number: 0,
        growth_height: 0,
        stage_name: ''
      },
      {
        growth_step: 4,
        integrated_temperature: 0,
        stem_number: 0,
        growth_height: 0,
        stage_name: ''
      },
      {
        growth_step: 5,
        integrated_temperature: 0,
        stem_number: 0,
        growth_height: 0,
        stage_name: ''
      }
    ],
    young_head_goals: [
      {
        young_head: 0,
        integrated_temperature: 0
      }
    ],
    harvest_period: {
      harvest_date_earliest: {
        integrated_temperature: 0,
        growth_height: 0
      },
      harvest_date_latest: {
        integrated_temperature: 0,
        growth_height: 0
      }
    },
    use_test_model: 0,
    test_stages: [
      {
        growth_step: 1,
        integrated_temperature: null,
        stage_name: ''
      },
      {
        growth_step: 2,
        integrated_temperature: null,
        stage_name: ''
      },
      {
        growth_step: 3,
        integrated_temperature: null,
        stage_name: ''
      },
      {
        growth_step: 4,
        integrated_temperature: null,
        stage_name: ''
      },
      {
        growth_step: 5,
        integrated_temperature: null,
        stage_name: ''
      }
    ],
    test_harvest_period: {
      harvest_date_earliest: {
        integrated_temperature: null,
        growth_height: null
      },
      harvest_date_latest: {
        integrated_temperature: null,
        growth_height: null
      }
    },
    remarks: ''
  }

  created () {
    this.varietyId = this.$route.params.variety_id
    this.getVarietyList()
    this.$store.commit('routeState/setRoute', this.$route.path)

    if (this.varietyData.use_test_model === 1) {
      this.testValueSelected.value = 1
    } else {
      this.testValueSelected.value = 0
    }
  }

  /* 生育マスタ詳細取得 */
  public getVarietyList () {
    (async () => {
      const result = await VarietyDetailApi.getVarietyDetail(this.varietyId)
      this.$store.commit('routeState/setRoute', this.$route.path)

      if (result.isOk()) {
        this.varietyData = result.getPayload()
        this.showLoading = false
      } else if (result.checkTimeoutErrorStatus()) {
        this.$store.commit('routeState/setTimeoutErrorFlag', true)
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkErrorStatus()) {
        this.$store.commit('routeState/setErrorFlag', true)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkNotFoundStatus()) {
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkStatus()) {
        CommonClass.doLogout()
      } else {
        this.showLoading = false
        this.showErrorAlert = true
        this.toastMessage = result.getPayload().message
      }
    })()
  }

  private doCancel () {
    this.$router.push('/variety')
  }

  private async doVarietyEdit () {
    this.showErrorAlert = false

    if (!this.isVarietyEdit()) {
      return
    }
    this.showLoading = true

    let bodyData: {[key: string]: any} = {
      stage_goals: [],
      young_head_goals: [],
      harvest_period: {
        harvest_date_earliest: {
          integrated_temperature: null,
          growth_height: null
        },
        harvest_date_latest: {
          integrated_temperature: null,
          growth_height: null
        }
      },
      use_test_model: null,
      test_stages: [],
      test_harvest_period: {
        harvest_date_earliest: {
          integrated_temperature: null,
          growth_height: null
        },
        harvest_date_latest: {
          integrated_temperature: null,
          growth_height: null
        }
      },
      remarks: null
    }

    /* 編集データ生成 */
    bodyData.use_test_model = this.varietyData.use_test_model
    bodyData.remarks = this.varietyData.remarks

    for (let i in this.varietyData.stage_goals) {
      bodyData.stage_goals.push({
        growth_step: parseInt(this.varietyData.stage_goals[i].growth_step),
        integrated_temperature: parseInt(this.varietyData.stage_goals[i].integrated_temperature),
        stem_number: parseInt(this.varietyData.stage_goals[i].stem_number),
        growth_height: parseInt(this.varietyData.stage_goals[i].growth_height)
      })
    }

    for (let i in this.varietyData.young_head_goals) {
      bodyData.young_head_goals.push({
        young_head: parseInt(this.varietyData.young_head_goals[i].young_head),
        integrated_temperature: parseInt(this.varietyData.young_head_goals[i].integrated_temperature)
      })
    }

    for (let i in this.varietyData.harvest_period) {
      if (this.varietyData.harvest_period[i].integrated_temperature) {
        bodyData.harvest_period[i].integrated_temperature = parseInt(this.varietyData.harvest_period[i].integrated_temperature)
      } else {
        bodyData.harvest_period[i].integrated_temperature = null
      }
      if (this.varietyData.harvest_period[i].growth_height) {
        bodyData.harvest_period[i].growth_height = parseInt(this.varietyData.harvest_period[i].growth_height)
      } else {
        bodyData.harvest_period[i].growth_height = null
      }
    }

    for (let i in this.varietyData.test_stages) {
      bodyData.test_stages.push({
        growth_step: parseInt(this.varietyData.test_stages[i].growth_step),
        integrated_temperature: parseInt(this.varietyData.test_stages[i].integrated_temperature)
      })
    }

    for (let i in this.varietyData.test_harvest_period) {
      if (this.varietyData.test_harvest_period[i].integrated_temperature) {
        bodyData.test_harvest_period[i].integrated_temperature = parseInt(this.varietyData.test_harvest_period[i].integrated_temperature)
      } else {
        bodyData.test_harvest_period[i].integrated_temperature = null
      }
      if (this.varietyData.test_harvest_period[i].growth_height) {
        bodyData.test_harvest_period[i].growth_height = parseInt(this.varietyData.test_harvest_period[i].growth_height)
      } else {
        bodyData.test_harvest_period[i].growth_height = null
      }
    }

    const result = await VarietyEditApi.doVarietyEdit(this.$route.params.variety_id, bodyData)

    if (result.isOk()) {
      this.showLoading = false
      this.$store.commit('alertState/setAlertMessage', '生育マスタ編集が完了しました。')
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/variety')
    } else if (result.checkTimeoutErrorStatus()) {
      this.$store.commit('routeState/setTimeoutErrorFlag', true)
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkErrorStatus()) {
      this.$store.commit('routeState/setErrorFlag', true)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkNotFoundStatus()) {
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkStatus()) {
      CommonClass.doLogout()
    } else {
      this.showLoading = false
      const payload = result.getPayload()
      if (payload.length === 0 || payload.message === '') {
        this.toastMessage = '入力内容に不備があります。'
      } else {
        this.toastMessage = payload.message
      }
      this.showErrorAlert = true
    }
  }

  /* バリデーション */
  private isVarietyEdit () {
    let stageGoalFlag: boolean
    let youngHeadGoalFlag: boolean = true
    let harvestPeriodFlag: boolean = true
    let testStageGoalFlag: boolean = true
    let testHarvestPeriodFlag: boolean = true
    let remarksFlag: boolean = true

    // エラーメッセージ初期化
    Object.keys(this.errorMessages).forEach(key => {
      this.$delete(this.errorMessages, key)
    })

    let isValid1: boolean = true
    let isValid2: boolean = true
    let isValid3: boolean = true
    /* 入力されているかチェック */
    for (let i in this.varietyData.stage_goals) {
      /* 積算温度 */
      if (isValid1 && (!this.varietyData.stage_goals[i].integrated_temperature && this.varietyData.stage_goals[i].integrated_temperature !== 0)) {
        this.$set(this.errorMessages, 'stageGoalIntegratedTemperatureErrorMessage', '積算温度は必ず入力してください。')
        isValid1 = false
      }
      /* 茎数 */
      if (isValid2 && (!this.varietyData.stage_goals[i].stem_number && this.varietyData.stage_goals[i].stem_number !== 0)) {
        this.$set(this.errorMessages, 'stageGoalStemErrorMessage', '茎数は必ず入力してください。')
        isValid2 = false
      }
      /* 草丈 */
      if (isValid3 && (!this.varietyData.stage_goals[i].growth_height && this.varietyData.stage_goals[i].growth_height !== 0)) {
        this.$set(this.errorMessages, 'stageGoalPlantHeightErrorMessage', '草丈は必ず入力してください。')
        isValid3 = false
      }
    }
    stageGoalFlag = isValid1 && isValid2 && isValid3

    for (let i in this.varietyData.young_head_goals) {
      /* 積算温度 */
      if (youngHeadGoalFlag && (!this.varietyData.young_head_goals[i].integrated_temperature && this.varietyData.young_head_goals[i].integrated_temperature !== 0)) {
        this.$set(this.errorMessages, 'youngHeadGoal1ErrorMessage', '積算温度は必ず入力してください。')
        youngHeadGoalFlag = false
      }
    }

    /* 上の項目より下の項目の値が大きいか、規定範囲内かチェック */
    for (let j in this.varietyData.stage_goals) {
      const data = this.varietyData.stage_goals[j]
      /* 積算温度 */
      if (j !== '0') {
        if (isNaN(data.integrated_temperature)) {
          this.$set(this.errorMessages, 'stageGoalIntegratedTemperatureError1Message', '積算温度は数値で入力してください。')
          stageGoalFlag = false
        } else if (parseInt(data.integrated_temperature) <= parseInt(this.varietyData.stage_goals[parseInt(j) - 1].integrated_temperature)) {
          this.$set(this.errorMessages, 'stageGoalIntegratedTemperatureError2Message', '積算温度は下位ステージより上位ステージの数値が大きくなるように入力してください。')
          stageGoalFlag = false
        } else if (parseInt(data.integrated_temperature) < 0 || parseInt(data.integrated_temperature) > 9999) {
          this.$set(this.errorMessages, 'stageGoalIntegratedTemperatureError3Message', '積算温度は0以上10000未満で入力してください。')
          stageGoalFlag = false
        }
      }
      /* 茎数 */
      if (j !== '0') {
        if (isNaN(data.stem_number)) {
          this.$set(this.errorMessages, 'stageGoalStemError1Message', '茎数は数値で入力してください。')
          stageGoalFlag = false
        } else if (parseInt(data.stem_number) < 0 || parseInt(data.stem_number) > 99) {
          this.$set(this.errorMessages, 'stageGoalStemError2Message', '茎数は0以上100未満で入力してください。')
          stageGoalFlag = false
        }
      }
      /* 草丈 */
      if (j !== '0') {
        if (isNaN(data.growth_height)) {
          this.$set(this.errorMessages, 'stageGoalPlantHeightError2Message', '草丈は数値で入力してください。')
          stageGoalFlag = false
        } else if (parseInt(data.growth_height) < 0 || parseInt(data.growth_height) > 999) {
          this.$set(this.errorMessages, 'stageGoalPlantHeightError1Message', '草丈は0以上1000未満で入力してください。')
          stageGoalFlag = false
        }
      }
    }

    for (let j in this.varietyData.young_head_goals) {
      const data = this.varietyData.young_head_goals[j]
      /* 積算温度 */
      if (isNaN(data.integrated_temperature)) {
        this.$set(this.errorMessages, 'youngHeadGoal4ErrorMessage', '積算温度は数値で入力してください。')
        youngHeadGoalFlag = false
      } else if (j !== '0' && parseInt(data.integrated_temperature) <= parseInt(this.varietyData.young_head_goals[parseInt(j) - 1].integrated_temperature) &&
        parseInt(data.integrated_temperature) !== 0 && parseInt(this.varietyData.young_head_goals[parseInt(j) - 1].integrated_temperature) !== 0) {
        this.$set(this.errorMessages, 'youngHeadGoal2ErrorMessage', '積算温度は下位幼穂長より上位幼穂長の数値が大きくなるように入力してください。')
        youngHeadGoalFlag = false
      } else if (parseInt(data.integrated_temperature) < 0 || parseInt(data.integrated_temperature) > 9999) {
        this.$set(this.errorMessages, 'youngHeadGoal3ErrorMessage', '積算温度は0以上10000未満で入力してください。')
        youngHeadGoalFlag = false
      }
    }

    /* 収穫最早期・収穫最遅期 */
    const harvestPeriodData = this.varietyData.harvest_period
    // 最早日（積算温度）か最遅日（積算温度）のどちらかに値があればバリデーションチェック
    if (!!harvestPeriodData.harvest_date_earliest.integrated_temperature || !!harvestPeriodData.harvest_date_latest.integrated_temperature) {
      if (parseInt(harvestPeriodData.harvest_date_earliest.integrated_temperature) >= parseInt(harvestPeriodData.harvest_date_latest.integrated_temperature)) {
        this.$set(this.errorMessages, 'harvestPeriod1ErrorMessage', '最早日（積算温度）より最遅日（積算温度）の数値が大きくなるように入力してください。')
        harvestPeriodFlag = false
      } else if ((!harvestPeriodData.harvest_date_earliest.integrated_temperature && !!harvestPeriodData.harvest_date_latest.integrated_temperature) ||
                 (!!harvestPeriodData.harvest_date_earliest.integrated_temperature && !harvestPeriodData.harvest_date_latest.integrated_temperature)) {
        this.$set(this.errorMessages, 'harvestPeriod2ErrorMessage', '最早日または最遅日の積算温度を設定する場合は、両方を必ず入力してください。')
        harvestPeriodFlag = false
      } else if (isNaN(harvestPeriodData.harvest_date_earliest.integrated_temperature) ||
                 isNaN(harvestPeriodData.harvest_date_latest.integrated_temperature)) {
        this.$set(this.errorMessages, 'harvestPeriod3ErrorMessage', '積算温度は数値で入力してください。')
        harvestPeriodFlag = false
      } else if (parseInt(harvestPeriodData.harvest_date_earliest.integrated_temperature) < 0 ||
                 parseInt(harvestPeriodData.harvest_date_earliest.integrated_temperature) > 9999 ||
                 parseInt(harvestPeriodData.harvest_date_latest.integrated_temperature) < 0 ||
                 parseInt(harvestPeriodData.harvest_date_latest.integrated_temperature) > 9999) {
        this.$set(this.errorMessages, 'harvestPeriod4ErrorMessage', '積算温度は0以上9999以下で入力してください。')
        harvestPeriodFlag = false
      } else if ((!!harvestPeriodData.harvest_date_earliest.integrated_temperature && !Number.isInteger(parseFloat(harvestPeriodData.harvest_date_earliest.integrated_temperature))) ||
                 (!!harvestPeriodData.harvest_date_latest.integrated_temperature && !Number.isInteger(parseFloat(harvestPeriodData.harvest_date_latest.integrated_temperature)))) {
        this.$set(this.errorMessages, 'harvestPeriod5ErrorMessage', '積算温度は整数で入力してください。')
        harvestPeriodFlag = false
      }
    }

    if (!!harvestPeriodData.harvest_date_earliest.growth_height || !!harvestPeriodData.harvest_date_latest.growth_height) {
      if (isNaN(harvestPeriodData.harvest_date_earliest.growth_height) ||
          isNaN(harvestPeriodData.harvest_date_latest.growth_height)) {
        this.$set(this.errorMessages, 'harvestPeriod6ErrorMessage', '草丈は数値で入力してください。')
        harvestPeriodFlag = false
      } else if (parseInt(harvestPeriodData.harvest_date_earliest.growth_height) < 0 ||
                 parseInt(harvestPeriodData.harvest_date_earliest.growth_height) > 999 ||
                 parseInt(harvestPeriodData.harvest_date_latest.growth_height) < 0 ||
                 parseInt(harvestPeriodData.harvest_date_latest.growth_height) > 999) {
        this.$set(this.errorMessages, 'harvestPeriod7ErrorMessage', '草丈は0以上999以下で入力してください。')
        harvestPeriodFlag = false
      } else if ((!!harvestPeriodData.harvest_date_earliest.growth_height && !Number.isInteger(parseFloat(harvestPeriodData.harvest_date_earliest.growth_height))) ||
                 (!!harvestPeriodData.harvest_date_latest.growth_height && !Number.isInteger(parseFloat(harvestPeriodData.harvest_date_latest.growth_height)))) {
        this.$set(this.errorMessages, 'harvestPeriod8ErrorMessage', '草丈は整数で入力してください。')
        harvestPeriodFlag = false
      }
    }

    /* グラフが有効の際、上の項目より下の項目の値が大きいか、規定範囲内かチェック */
    for (let j in this.varietyData.test_stages) {
      const data = this.varietyData.test_stages[j]
      /* 積算温度 */
      if (j !== '0' && this.varietyData.use_test_model === 1) {
        if ((!this.varietyData.test_stages[j].integrated_temperature && this.varietyData.test_stages[j].integrated_temperature !== 0)) {
          this.$set(this.errorMessages, 'testStageGoalIntegratedTemperatureErrorMessage', '積算温度は必ず入力してください。')
          testStageGoalFlag = false
        } else if (parseInt(data.integrated_temperature) <= parseInt(this.varietyData.test_stages[parseInt(j) - 1].integrated_temperature)) {
          this.$set(this.errorMessages, 'testStageGoalIntegratedTemperatureError2Message', '積算温度は下位ステージより上位ステージの数値が大きくなるように入力してください。')
          testStageGoalFlag = false
        }
      }
      /* グラフが有効・無効に限らずチェック */
      if (j !== '0') {
        if (isNaN(data.integrated_temperature)) {
          this.$set(this.errorMessages, 'testStageGoalIntegratedTemperatureError1Message', '積算温度は数値で入力してください。')
          testStageGoalFlag = false
        } else if (parseInt(data.integrated_temperature) < 0 || parseInt(data.integrated_temperature) > 9999) {
          this.$set(this.errorMessages, 'testStageGoalIntegratedTemperatureError3Message', '積算温度は0以上10000未満で入力してください。')
          testStageGoalFlag = false
        }
      }
    }

    /* 検証収穫最早期・収穫最遅期 */
    const testHarvestPeriodData = this.varietyData.test_harvest_period
    /* グラフが有効の場合 */
    if (this.varietyData.use_test_model === 1) {
      /* 積算温度 ※最早日（積算温度）か最遅日（積算温度）のどちらかに値があればバリデーションチェック */
      if (!!testHarvestPeriodData.harvest_date_earliest.integrated_temperature || !!testHarvestPeriodData.harvest_date_latest.integrated_temperature) {
        if (parseInt(testHarvestPeriodData.harvest_date_earliest.integrated_temperature) >= parseInt(testHarvestPeriodData.harvest_date_latest.integrated_temperature)) {
          this.$set(this.errorMessages, 'testHarvestPeriod1ErrorMessage', '最早日（積算温度）より最遅日（積算温度）の数値が大きくなるように入力してください。')
          testHarvestPeriodFlag = false
        } else if ((!testHarvestPeriodData.harvest_date_earliest.integrated_temperature && !!testHarvestPeriodData.harvest_date_latest.integrated_temperature) ||
                  (!!testHarvestPeriodData.harvest_date_earliest.integrated_temperature && !testHarvestPeriodData.harvest_date_latest.integrated_temperature)) {
          this.$set(this.errorMessages, 'testHarvestPeriod2ErrorMessage', '最早日または最遅日の積算温度を設定する場合は、両方を必ず入力してください。')
          testHarvestPeriodFlag = false
        }
      }
    }
    /* グラフが有効・無効に限らずチェック */
    if (isNaN(testHarvestPeriodData.harvest_date_earliest.integrated_temperature) || isNaN(testHarvestPeriodData.harvest_date_latest.integrated_temperature)) {
      this.$set(this.errorMessages, 'testHarvestPeriod3ErrorMessage', '積算温度は数値で入力してください。')
      testHarvestPeriodFlag = false
    } else if (parseInt(testHarvestPeriodData.harvest_date_earliest.integrated_temperature) < 0 ||
              parseInt(testHarvestPeriodData.harvest_date_earliest.integrated_temperature) > 9999 ||
              parseInt(testHarvestPeriodData.harvest_date_latest.integrated_temperature) < 0 ||
              parseInt(testHarvestPeriodData.harvest_date_latest.integrated_temperature) > 9999) {
      this.$set(this.errorMessages, 'testHarvestPeriod4ErrorMessage', '積算温度は0以上9999以下で入力してください。')
      testHarvestPeriodFlag = false
    } else if ((!!testHarvestPeriodData.harvest_date_earliest.integrated_temperature && !Number.isInteger(parseFloat(testHarvestPeriodData.harvest_date_earliest.integrated_temperature))) ||
              (!!testHarvestPeriodData.harvest_date_latest.integrated_temperature && !Number.isInteger(parseFloat(testHarvestPeriodData.harvest_date_latest.integrated_temperature)))) {
      this.$set(this.errorMessages, 'testHarvestPeriod5ErrorMessage', '積算温度は整数で入力してください。')
      testHarvestPeriodFlag = false
    }

    // 草丈
    if (!!testHarvestPeriodData.harvest_date_earliest.growth_height || !!testHarvestPeriodData.harvest_date_latest.growth_height) {
      if (isNaN(testHarvestPeriodData.harvest_date_earliest.growth_height) ||
          isNaN(testHarvestPeriodData.harvest_date_latest.growth_height)) {
        this.$set(this.errorMessages, 'testHarvestPeriod6ErrorMessage', '草丈は数値で入力してください。')
        testHarvestPeriodFlag = false
      } else if (parseInt(testHarvestPeriodData.harvest_date_earliest.growth_height) < 0 ||
                 parseInt(testHarvestPeriodData.harvest_date_earliest.growth_height) > 999 ||
                 parseInt(testHarvestPeriodData.harvest_date_latest.growth_height) < 0 ||
                 parseInt(testHarvestPeriodData.harvest_date_latest.growth_height) > 999) {
        this.$set(this.errorMessages, 'testHarvestPeriod7ErrorMessage', '草丈は0以上999以下で入力してください。')
        testHarvestPeriodFlag = false
      } else if ((!!testHarvestPeriodData.harvest_date_earliest.growth_height && !Number.isInteger(parseFloat(testHarvestPeriodData.harvest_date_earliest.growth_height))) ||
                 (!!testHarvestPeriodData.harvest_date_latest.growth_height && !Number.isInteger(parseFloat(testHarvestPeriodData.harvest_date_latest.growth_height)))) {
        this.$set(this.errorMessages, 'testHarvestPeriod8ErrorMessage', '草丈は整数で入力してください。')
        testHarvestPeriodFlag = false
      }
    }

    // 備考
    const remarksData = this.varietyData.remarks
    if (remarksData) {
      if (remarksData.length > 500) {
        this.$set(this.errorMessages, 'remarksErrorMessage', '備考は500文字以下で入力してください。')
        remarksFlag = false
      }
    }

    return stageGoalFlag && youngHeadGoalFlag && harvestPeriodFlag && testStageGoalFlag && testHarvestPeriodFlag && remarksFlag
  }

  /* 目標値矢印押下 */
  private upStageIntegratedTemperatureNumber (key: number) {
    if (parseInt(this.varietyData.stage_goals[key].integrated_temperature) < 9999) {
      this.varietyData.stage_goals[key].integrated_temperature = parseInt(this.varietyData.stage_goals[key].integrated_temperature) + 1
    }
  }

  private downStageIntegratedTemperatureNumber (key: number) {
    if (parseInt(this.varietyData.stage_goals[key].integrated_temperature) > 0) {
      this.varietyData.stage_goals[key].integrated_temperature = parseInt(this.varietyData.stage_goals[key].integrated_temperature) - 1
    }
  }

  private upStageStemNumber (key: number) {
    if (parseInt(this.varietyData.stage_goals[key].stem_number) < 99) {
      this.varietyData.stage_goals[key].stem_number = parseInt(this.varietyData.stage_goals[key].stem_number) + 1
    }
  }

  private downStageStemNumber (key: number) {
    if (parseInt(this.varietyData.stage_goals[key].stem_number) > 0) {
      this.varietyData.stage_goals[key].stem_number = parseInt(this.varietyData.stage_goals[key].stem_number) - 1
    }
  }

  private upStageGrowthHeightNumber (key: number) {
    if (parseInt(this.varietyData.stage_goals[key].growth_height) < 999) {
      this.varietyData.stage_goals[key].growth_height = parseInt(this.varietyData.stage_goals[key].growth_height) + 1
    }
  }

  private downStageGrowthHeightNumber (key: number) {
    if (parseInt(this.varietyData.stage_goals[key].growth_height) > 0) {
      this.varietyData.stage_goals[key].growth_height = parseInt(this.varietyData.stage_goals[key].growth_height) - 1
    }
  }

  private upYoungHeadIntegratedTemperatureNumber (key: number) {
    if (parseInt(this.varietyData.young_head_goals[key].integrated_temperature) < 9999) {
      this.varietyData.young_head_goals[key].integrated_temperature = parseInt(this.varietyData.young_head_goals[key].integrated_temperature) + 1
    }
  }

  private downYoungHeadIntegratedTemperatureNumber (key: number) {
    if (parseInt(this.varietyData.young_head_goals[key].integrated_temperature) > 0) {
      this.varietyData.young_head_goals[key].integrated_temperature = parseInt(this.varietyData.young_head_goals[key].integrated_temperature) - 1
    }
  }

  private upHarvestDateEarliestIntegratedTemperatureNumber () {
    if (parseInt(this.varietyData.harvest_period.harvest_date_earliest.integrated_temperature) < 9999) {
      this.varietyData.harvest_period.harvest_date_earliest.integrated_temperature = parseInt(this.varietyData.harvest_period.harvest_date_earliest.integrated_temperature) + 1
    }
  }

  private downHarvestDateEarliestIntegratedTemperatureNumber () {
    if (parseInt(this.varietyData.harvest_period.harvest_date_earliest.integrated_temperature) > 0) {
      this.varietyData.harvest_period.harvest_date_earliest.integrated_temperature = parseInt(this.varietyData.harvest_period.harvest_date_earliest.integrated_temperature) - 1
    }
  }

  private upHarvestDateEarliestGrouwthHeightNumber () {
    if (parseInt(this.varietyData.harvest_period.harvest_date_earliest.growth_height) < 999) {
      this.varietyData.harvest_period.harvest_date_earliest.growth_height = parseInt(this.varietyData.harvest_period.harvest_date_earliest.growth_height) + 1
    }
  }

  private downHarvestDateEarliestGrouwthHeightNumber () {
    if (parseInt(this.varietyData.harvest_period.harvest_date_earliest.growth_height) > 0) {
      this.varietyData.harvest_period.harvest_date_earliest.growth_height = parseInt(this.varietyData.harvest_period.harvest_date_earliest.growth_height) - 1
    }
  }

  private upHarvestDateLatestIntegratedTemperatureNumber () {
    if (parseInt(this.varietyData.harvest_period.harvest_date_latest.integrated_temperature) < 9999) {
      this.varietyData.harvest_period.harvest_date_latest.integrated_temperature = parseInt(this.varietyData.harvest_period.harvest_date_latest.integrated_temperature) + 1
    }
  }

  private downHarvestDateLatestIntegratedTemperatureNumber () {
    if (parseInt(this.varietyData.harvest_period.harvest_date_latest.integrated_temperature) > 0) {
      this.varietyData.harvest_period.harvest_date_latest.integrated_temperature = parseInt(this.varietyData.harvest_period.harvest_date_latest.integrated_temperature) - 1
    }
  }

  private upHarvestDateLatestGrouwthHeightNumber () {
    if (parseInt(this.varietyData.harvest_period.harvest_date_latest.growth_height) < 999) {
      this.varietyData.harvest_period.harvest_date_latest.growth_height = parseInt(this.varietyData.harvest_period.harvest_date_latest.growth_height) + 1
    }
  }

  private downHarvestDateLatestGrouwthHeightNumber () {
    if (parseInt(this.varietyData.harvest_period.harvest_date_latest.growth_height) > 0) {
      this.varietyData.harvest_period.harvest_date_latest.growth_height = parseInt(this.varietyData.harvest_period.harvest_date_latest.growth_height) - 1
    }
  }

  // 検証グラフ
  private upTestStageIntegratedTemperatureNumber (key: number) {
    if (parseInt(this.varietyData.test_stages[key].integrated_temperature) < 9999) {
      this.varietyData.test_stages[key].integrated_temperature = parseInt(this.varietyData.test_stages[key].integrated_temperature) + 1
    }
  }

  private downTestStageIntegratedTemperatureNumber (key: number) {
    if (parseInt(this.varietyData.test_stages[key].integrated_temperature) > 0) {
      this.varietyData.test_stages[key].integrated_temperature = parseInt(this.varietyData.test_stages[key].integrated_temperature) - 1
    }
  }

  private upTestHarvestDateEarliestIntegratedTemperatureNumber () {
    if (parseInt(this.varietyData.test_harvest_period.harvest_date_earliest.integrated_temperature) < 9999) {
      this.varietyData.test_harvest_period.harvest_date_earliest.integrated_temperature = parseInt(this.varietyData.test_harvest_period.harvest_date_earliest.integrated_temperature) + 1
    }
  }

  private downTestHarvestDateEarliestIntegratedTemperatureNumber () {
    if (parseInt(this.varietyData.test_harvest_period.harvest_date_earliest.integrated_temperature) > 0) {
      this.varietyData.test_harvest_period.harvest_date_earliest.integrated_temperature = parseInt(this.varietyData.test_harvest_period.harvest_date_earliest.integrated_temperature) - 1
    }
  }

  private upTestHarvestDateEarliestGrouwthHeightNumber () {
    if (parseInt(this.varietyData.test_harvest_period.harvest_date_earliest.growth_height) < 999) {
      this.varietyData.test_harvest_period.harvest_date_earliest.growth_height = parseInt(this.varietyData.test_harvest_period.harvest_date_earliest.growth_height) + 1
    }
  }

  private downTestHarvestDateEarliestGrouwthHeightNumber () {
    if (parseInt(this.varietyData.test_harvest_period.harvest_date_earliest.growth_height) > 0) {
      this.varietyData.test_harvest_period.harvest_date_earliest.growth_height = parseInt(this.varietyData.test_harvest_period.harvest_date_earliest.growth_height) - 1
    }
  }

  private upTestHarvestDateLatestIntegratedTemperatureNumber () {
    if (parseInt(this.varietyData.test_harvest_period.harvest_date_latest.integrated_temperature) < 9999) {
      this.varietyData.test_harvest_period.harvest_date_latest.integrated_temperature = parseInt(this.varietyData.test_harvest_period.harvest_date_latest.integrated_temperature) + 1
    }
  }

  private downTestHarvestDateLatestIntegratedTemperatureNumber () {
    if (parseInt(this.varietyData.test_harvest_period.harvest_date_latest.integrated_temperature) > 0) {
      this.varietyData.test_harvest_period.harvest_date_latest.integrated_temperature = parseInt(this.varietyData.test_harvest_period.harvest_date_latest.integrated_temperature) - 1
    }
  }

  private upTestHarvestDateLatestGrouwthHeightNumber () {
    if (parseInt(this.varietyData.test_harvest_period.harvest_date_latest.growth_height) < 999) {
      this.varietyData.test_harvest_period.harvest_date_latest.growth_height = parseInt(this.varietyData.test_harvest_period.harvest_date_latest.growth_height) + 1
    }
  }

  private downTestHarvestDateLatestGrouwthHeightNumber () {
    if (parseInt(this.varietyData.test_harvest_period.harvest_date_latest.growth_height) > 0) {
      this.varietyData.test_harvest_period.harvest_date_latest.growth_height = parseInt(this.varietyData.test_harvest_period.harvest_date_latest.growth_height) - 1
    }
  }

  private closeAlert () {
    this.showErrorAlert = false
  }
}
